const svg = (body: string, size = 20): string =>
  `<svg viewBox="0 0 24 24" width="${size}" height="${size}" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${body}</svg>`;

export function mark(size = 22): string {
  return `<svg viewBox="0 0 24 24" width="${size}" height="${size}" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" aria-hidden="true"><path d="M12 3v18M3 12h18M5.6 5.6l12.8 12.8M18.4 5.6L5.6 18.4"/></svg>`;
}

export function sun(size = 18): string {
  return svg(
    '<circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41"/>',
    size,
  );
}

export function moon(size = 18): string {
  return svg('<path d="M20.5 14.4A8.5 8.5 0 0 1 9.6 3.5 8.5 8.5 0 1 0 20.5 14.4Z"/>', size);
}

export function paperclip(size = 18): string {
  return svg(
    '<path d="M21 11.5 12.2 20.3a6 6 0 0 1-8.5-8.5l9.2-9.2a4 4 0 0 1 5.7 5.7l-9.3 9.2a2 2 0 0 1-2.8-2.8l8.5-8.5"/>',
    size,
  );
}

export function arrowUp(size = 18): string {
  return svg('<path d="M12 19V5M5 12l7-7 7 7"/>', size);
}

export function plus(size = 18): string {
  return svg('<path d="M12 5v14M5 12h14"/>', size);
}

export function logout(size = 18): string {
  return svg('<path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9"/>', size);
}

export function copy(size = 15): string {
  return svg(
    '<rect x="9" y="9" width="12" height="12" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/>',
    size,
  );
}

export function check(size = 15): string {
  return svg('<path d="m5 12 4.5 4.5L19 7"/>', size);
}

export function x(size = 16): string {
  return svg('<path d="M18 6 6 18M6 6l12 12"/>', size);
}

export function file(size = 16): string {
  return svg('<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8Z"/><path d="M14 2v6h6"/>', size);
}

export function download(size = 15): string {
  return svg('<path d="M12 3v12M7 10l5 5 5-5M5 21h14"/>', size);
}

export function alert(size = 17): string {
  return svg('<circle cx="12" cy="12" r="9"/><path d="M12 8v5M12 16h.01"/>', size);
}

export function sparkle(size = 16): string {
  return svg('<path d="M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8Z"/>', size);
}

export function eye(size = 17): string {
  return svg('<path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Z"/><circle cx="12" cy="12" r="3"/>', size);
}

export function eyeOff(size = 17): string {
  return svg('<path d="m3 3 18 18M10.6 5.2A11 11 0 0 1 12 5c6.5 0 10 7 10 7a18 18 0 0 1-3 4M6.5 6.5C3.6 8.4 2 12 2 12s3.5 7 10 7c1.6 0 3-.4 4.2-1M9.9 9.9a3 3 0 0 0 4.2 4.2"/>', size);
}

export function shield(size = 17): string {
  return svg('<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Z"/>', size);
}

export function lock(size = 17): string {
  return svg('<rect x="4" y="11" width="16" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/>', size);
}
